import React, { Component } from 'react';
import { ComboBox as CarbonComboBox } from 'carbon-components-react';
import isEqual from 'lodash.isequal';

export class ComboBox extends React.Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !isEqual(nextProps, this.props);
    }

    render() {
        const {
            name,
            alt,
            onChange,
            id,
            items,
            disableClear,
            ...initProps
        } = this.props;

        const _onChange = ({ selectedItem }) => {

            //props.onChange(inputName, selectedItem, objName);
            return this.props.onChange(name, selectedItem, alt);
        };

        return (
            <CarbonComboBox
                {
                ...initProps
                }
                id={'cbx_' + id}
                items={items || []}
                onChange={_onChange}
                className={disableClear ? "disable-clear" : ""}
            />);
    }
}